(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["knjige-scroll-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('book-scroll-showcase')) return;

    var SCROLL_MQ = '(min-width: 1000px) and (prefers-reduced-motion: no-preference)';
    var REVEAL_SPAN = 0.65; // v katerem delu odseka knjige se razkrije vse (preostanek = čas za branje)
    var REVEAL_LEAD = 0.12; // prvi element se pokaže malo pred pripetjem
    var HOLD_STEPS = 1.2;   // naslov najprej nekaj časa miruje povečan
    var LIFT_STEPS = 4;     // koliko »korakov« traja pomanjšanje in dvig naslova
    var LEAD_STEPS = 0.8;   // naslov se pojavi malo preden se section pripne
    var ease = function (x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };

    class BookScrollShowcase extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bss__track');
        this.sticky = this.querySelector('.bss__sticky');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.images = Array.from(this.querySelectorAll('[data-image]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.count = this.slides.length;
        if (!this.count) return;

        this.slides.forEach((slide) => this.prepareSlide(slide));

        this.mq = window.matchMedia(SCROLL_MQ);
        this.reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.ticking = false;

        this._onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.ticking = false; this.update(); });
        };
        this._onResize = () => { this.measure(); if (this.isScrollMode()) this._onScroll(); };
        this._onMq = () => this.setMode();
        this._onMobileScroll = () => {
          if (this.mTicking) return;
          this.mTicking = true;
          requestAnimationFrame(() => { this.mTicking = false; this.mobileUpdate(); });
        };
        this._onSubmit = (e) => this.handleSubmit(e);
        this._onBlockSelect = (e) => this.onBlockSelect(e);

        this.mq.addEventListener('change', this._onMq);
        this.addEventListener('submit', this._onSubmit);
        document.addEventListener('shopify:block:select', this._onBlockSelect);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.scrollToSlide(i)));

        try {
          this.classList.add('is-ready');
          this.setupImageReveal();
          this.setMode();
          window.addEventListener('load', this._onResize, { once: true });
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._onResize);
        } catch (err) {
          this.failOpen(err);
        }
        this.debug();
      }

      // Če karkoli odpove, pokaži vse brez animacije
      failOpen(err) {
        this.lastError = err && err.message ? err.message : String(err);
        try { this.teardown(); } catch (_) {}
        this.classList.remove('is-ready', 'is-d-ready', 'is-m-ready');
        this.classList.add('is-revealed');
        (this.slides || []).forEach((slide) => {
          slide.classList.add('is-active');
          slide.removeAttribute('inert');
          slide.removeAttribute('aria-hidden');
          slide.querySelectorAll('.bss__r').forEach((el) => { el.classList.add('is-visible'); el.classList.remove('is-pending'); });
          var c = slide.querySelector('[data-content]');
          if (c) { c.style.removeProperty('--bss-head-scale'); c.style.removeProperty('--bss-shift'); }
        });
        if (window.console) console.warn('[book-scroll-showcase]', err);
      }

      // Diagnostika: dodaj ?bss-debug na konec naslova strani
      debug() {
        if (!/bss-debug/.test(location.search + location.hash)) return;
        var box = document.createElement('div');
        box.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:99999;background:#000;color:#0f0;font:11px/1.4 monospace;padding:6px 8px;border-radius:6px;max-width:92vw;white-space:pre-wrap;pointer-events:none';
        document.body.appendChild(box);
        var n = 0;
        document.addEventListener('scroll', () => { n++; }, { capture: true, passive: true });
        setInterval(() => {
          var all = this.querySelectorAll('.bss__r');
          var pend = this.querySelectorAll('.bss__r.is-pending').length;
          box.textContent = 'mode: ' + (this.isScrollMode && this.mq ? (this.isScrollMode() ? 'desktop' : 'mobile') : '?') +
            ' | classes: ' + this.className.replace(/bss--\S+/g, '').trim() +
            '\nitems: ' + all.length + ' pending: ' + pend +
            ' | scroll events: ' + n + ' | scrollY: ' + Math.round(window.scrollY) +
            '\nvh: ' + window.innerHeight + ' | reduce-motion: ' + (this.reduceMq && this.reduceMq.matches) +
            (this.lastError ? '\nERROR: ' + this.lastError : '');
        }, 400);
        window.addEventListener('error', (e) => { this.lastError = e.message; });
      }

      disconnectedCallback() {
        this.teardown();
        if (this.mq) this.mq.removeEventListener('change', this._onMq);
        if (this.revealIo) this.revealIo.disconnect();
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
      }

      // Zgradi vrstni red razkrivanja: glava → "dvig" → odstavki / povezava / gumb
      prepareSlide(slide) {
        var head = slide.querySelector('[data-head]');
        var body = slide.querySelector('[data-body]');
        slide._content = slide.querySelector('[data-content]');
        slide._body = body;
        slide._head = head ? Array.from(head.querySelectorAll('[data-reveal]')) : [];
        slide._bodyItems = [];
        if (body) {
          Array.from(body.children).forEach((el) => {
            if (el.hasAttribute('data-reveal-children')) slide._bodyItems.push.apply(slide._bodyItems, Array.from(el.children));
            else slide._bodyItems.push(el);
          });
        }
        slide._head.concat(slide._bodyItems).forEach((el, i) => {
          el.classList.add('bss__r');
          el.style.setProperty('--i', i);
        });
      }

      teardown() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
        document.removeEventListener('scroll', this._onMobileScroll, true);
        window.removeEventListener('scroll', this._onMobileScroll);
        window.removeEventListener('resize', this._onMobileScroll);
        window.removeEventListener('touchmove', this._onMobileScroll);
        window.removeEventListener('orientationchange', this._onMobileScroll);
        if (this.io) { this.io.disconnect(); this.io = null; }
        clearInterval(this.mobilePoll);
        this.mobileItems = [];
        this.classList.remove('is-m-ready', 'is-d-ready');
        (this.slides || []).forEach((slide) => {
          slide.classList.remove('is-pending-media');
          var media = slide.querySelector('.bss__mobile-media');
          if (media) { media.style.transform = ''; media.style.opacity = ''; }
          if (slide._content) slide._content.style.removeProperty('--bss-head-scale');
          (slide._head || []).concat(slide._bodyItems || []).forEach((el) => { el.style.transitionDelay = ''; el.classList.remove('is-pending'); });
        });
      }

      isScrollMode() { return this.mq.matches; }

      setMode() {
        this.teardown();
        if (this.isScrollMode()) {
          window.addEventListener('scroll', this._onScroll, { passive: true });
          window.addEventListener('resize', this._onResize);
          this.measure();
          this.update();
          this.classList.add('is-d-ready');
          return;
        }
        // Stack mode (mobilno / reduced motion)
        this.style.removeProperty('--bss-min-h');
        this.slides.forEach((slide) => {
          slide.classList.add('is-active');
          slide.removeAttribute('inert');
          slide.removeAttribute('aria-hidden');
          if (slide._content) slide._content.style.removeProperty('--bss-shift');
        });
        this.slides.forEach((slide) => this.revealAll(slide));
        if (this.reduceMq.matches) return;

        // Mobilno: vse je vidno. Skrijemo samo tisto, kar je trenutno pod zaslonom,
        // in to razkrijemo, ko pride v zaslon. Če karkoli odpove, besedilo ostane vidno.
        var vh = this.viewportH();
        this.mobileItems = [];
        this.slides.forEach((slide) => {
          if (slide.getBoundingClientRect().top > vh * 0.9) slide.classList.add('is-pending-media');
          var zoomM = (parseFloat(this.dataset.zoomM) || 100) > 100;
          slide._head.forEach((el) => {
            if (el.getBoundingClientRect().top > vh * 0.9) { el.classList.add('is-pending'); this.mobileItems.push(el); }
          });
          var slideBelow = slide._content.getBoundingClientRect().top > vh * 0.45;
          slide._bodyItems.forEach((el) => {
            if (el.getBoundingClientRect().top > vh * 0.9 || (zoomM && slideBelow)) { el.classList.add('is-pending'); this.mobileItems.push(el); }
          });
        });

        // zaznaj skrolanje ne glede na to, kateri element skrola (iOS Safari)
        document.addEventListener('scroll', this._onMobileScroll, { capture: true, passive: true });
        window.addEventListener('scroll', this._onMobileScroll, { passive: true });
        window.addEventListener('resize', this._onMobileScroll);
        window.addEventListener('touchmove', this._onMobileScroll, { passive: true });
        window.addEventListener('orientationchange', this._onMobileScroll);
        // rezervno preverjanje, dokler kaj še čaka
        clearInterval(this.mobilePoll);
        this.mobilePoll = setInterval(() => this.mobileUpdate(), 300);

        var wantedM = (parseFloat(this.dataset.zoomM) || 100) / 100;
        this.slides.forEach((slide) => {
          slide._content.style.setProperty('--bss-head-scale', 1);
          slide._zoom = this.headZoom(slide, wantedM, true);
          slide._headDone = slide._zoom <= 1;
        });

        this.classList.add('is-m-ready');
        this.mobileUpdate();
      }

      // Mobilno: naslov se manjša, ko list z besedilom pride v zgornji del zaslona
      mobileHead(vh) {
        this.slides.forEach((slide) => {
          if (!slide._zoom || slide._zoom <= 1) { slide._headDone = true; return; }
          var ct = slide._content.getBoundingClientRect().top;
          var p = ease(Math.min(1, Math.max(0, (vh * 0.85 - ct) / (vh * 0.45))));
          slide._content.style.setProperty('--bss-head-scale', (slide._zoom + (1 - slide._zoom) * p).toFixed(4));
          slide._headDone = p >= 0.98;
        });
      }

      viewportH() {
        return (window.visualViewport && window.visualViewport.height) || window.innerHeight || document.documentElement.clientHeight || 800;
      }

      mobileUpdate() {
        try {
          var vh = this.viewportH();
          this.mobileHead(vh);
          var k = 0;
          this.mobileItems = (this.mobileItems || []).filter((el) => {
            var r = el.getBoundingClientRect();
            var slide = el.closest('[data-slide]');
            var gated = slide && !slide._headDone && slide._bodyItems.indexOf(el) > -1;
            if (r.top < vh * 0.9 && !gated) {
              el.style.transitionDelay = (k++ * 110) + 'ms';
              el.classList.remove('is-pending');
              return false;
            }
            return true;
          });
          this.slides.forEach((slide) => {
            if (slide.classList.contains('is-pending-media') && slide.getBoundingClientRect().top < vh * 0.9) slide.classList.remove('is-pending-media');
          });
          if (!this.mobileItems.length) clearInterval(this.mobilePoll);
          if (this.classList.contains('bss--m-sheet')) this.sheetUpdate();
        } catch (err) {
          this.failOpen(err);
        }
      }

      sheetUpdate() {
        this.slides.forEach((slide) => {
          var media = slide.querySelector('.bss__mobile-media');
          if (!media || !slide._content) return;
          var mh = media.offsetHeight || 1;
          var top = parseFloat(getComputedStyle(media).top) || 0;
          var ct = slide._content.getBoundingClientRect().top;
          var o = Math.min(1, Math.max(0, (top + mh - ct) / mh));
          media.style.transform = 'scale(' + (1 - 0.06 * o).toFixed(4) + ')';
          media.style.opacity = (1 - 0.45 * o).toFixed(3);
        });
      }

      // Section mora biti vsaj tako visok, da gre celotno besedilo noter
      measure() {
        if (!this.isScrollMode()) return;
        var wanted = (parseFloat(this.dataset.zoom) || 100) / 100;
        this.slides.forEach((slide) => {
          slide._content.style.setProperty('--bss-head-scale', 1);
          slide._zoom = this.headZoom(slide, wanted, false);
        });
        var max = 0;
        this.slides.forEach((slide) => {
          var cs = getComputedStyle(slide);
          var h = slide._content.offsetHeight + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
          if (h > max) max = h;
        });
        this.style.setProperty('--bss-min-h', Math.ceil(max) + 'px');
      }

      setupImageReveal() {
        if (!this.classList.contains('bss--reveal')) return;
        if (!('IntersectionObserver' in window)) { this.classList.add('is-revealed'); return; }
        this.revealIo = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.classList.add('is-revealed');
            this.revealIo.disconnect();
          }
        }, { threshold: 0.2 });
        this.revealIo.observe(this.sticky);
      }

      revealAll(slide) {
        slide._head.concat(slide._bodyItems).forEach((el) => { el.classList.add('is-visible'); el.classList.remove('is-pending'); });
      }

      // visible = število korakov; koraki: [glava..., dvig, telo...]
      // Največja povečava naslova, da ne seže čez rob besedilnega polja
      headZoom(slide, wanted, mobile) {
        if (wanted <= 1 || !slide._head.length) return 1;
        var headW = 0, headH = 0;
        slide._head.forEach((el) => { headW = Math.max(headW, el.offsetWidth); headH += el.offsetHeight; });
        if (!headW) return 1;
        var box = mobile ? slide._content : slide;
        var cs = getComputedStyle(box);
        var inner = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        var align = this.classList.contains('bss--align-center') ? 'center' : (this.classList.contains('bss--align-right') ? 'right' : 'left');
        var avail = align === 'center' ? box.clientWidth * 0.94 : inner + parseFloat(cs.paddingRight) * 0.5;
        var z = Math.min(wanted, avail / headW);
        if (!mobile) z = Math.min(z, (slide.clientHeight * 0.8) / Math.max(1, headH));
        return Math.max(1, z);
      }

      // s = zvezni napredek v »korakih«: [glava..., pomanjšanje + dvig, telo...]
      applyProgress(slide, s) {
        slide._head.forEach((el, k) => el.classList.toggle('is-visible', s >= k * 0.35));
        var p = ease(Math.min(1, Math.max(0, (s - HOLD_STEPS) / LIFT_STEPS)));
        slide._bodyItems.forEach((el, j) => el.classList.toggle('is-visible', s >= HOLD_STEPS + LIFT_STEPS + j));
        var bodyH = slide._body ? slide._body.offsetHeight : 0;
        slide._content.style.setProperty('--bss-shift', (bodyH / 2 * (1 - p)).toFixed(1) + 'px');
        var z = slide._zoom || 1;
        slide._content.style.setProperty('--bss-head-scale', (z + (1 - z) * p).toFixed(4));
      }

      metrics() {
        var rect = this.track.getBoundingClientRect();
        var top = parseFloat(getComputedStyle(this.sticky).top) || 0;
        var total = Math.max(1, this.track.offsetHeight - this.sticky.offsetHeight);
        return { rect: rect, top: top, total: total };
      }

      update() {
        var m = this.metrics();
        var raw = (m.top - m.rect.top) / m.total;
        var pos = Math.min(Math.max(raw, 0), 0.9999) * this.count;
        var index = Math.floor(pos);
        var local = raw * this.count - index;

        this.slides.forEach((slide, i) => {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', String(!active));

          var steps = HOLD_STEPS + LIFT_STEPS + slide._bodyItems.length;
          if (i < index) this.applyProgress(slide, steps);
          else if (i > index) this.applyProgress(slide, -1);
          else this.applyProgress(slide, Math.min(steps, local / REVEAL_SPAN * steps + (i === 0 ? LEAD_STEPS : 0)));
        });

        this.images.forEach((img, i) => img.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }

      scrollToSlide(i, behavior) {
        if (!this.isScrollMode()) {
          if (this.slides[i]) this.slides[i].scrollIntoView({ behavior: behavior || 'smooth', block: 'start' });
          return;
        }
        var m = this.metrics();
        var trackTop = window.scrollY + m.rect.top - m.top;
        var target = trackTop + ((i + REVEAL_SPAN + 0.05) / this.count) * m.total;
        window.scrollTo({ top: target, behavior: behavior || 'smooth' });
      }

      onBlockSelect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        var i = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
        if (i > -1) setTimeout(() => this.scrollToSlide(i, 'auto'), 60);
      }

      async handleSubmit(e) {
        var form = e.target.closest('form[data-bss-cart]');
        if (!form) return;
        e.preventDefault();

        var button = form.querySelector('[type="submit"]');
        var label = button.querySelector('[data-label]');
        var original = label.textContent;
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        try {
          var res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          var data = await res.json();
          if (!res.ok) {
            var err = new Error(data.description || data.message || 'Napaka');
            err.userFacing = true;
            throw err;
          }
          var cart = await fetch(root + 'cart.js').then((r) => r.json());

          var html = document.documentElement;
          html.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: [data], cart: cart } }));
          html.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') { try { drawer.show(); } catch (_) {} }

          label.textContent = 'Dodano ✓';
          setTimeout(() => { label.textContent = original; }, 2200);
        } catch (err) {
          if (err.userFacing) {
            label.textContent = err.message;
            setTimeout(() => { label.textContent = original; }, 3000);
          } else {
            HTMLFormElement.prototype.submit.call(form);
            return;
          }
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('book-scroll-showcase', BookScrollShowcase);
  })();

  } catch(e) { console.error(e); }
})();
})();
